<div
  class="lt-text-input"
  [class.lt-text-input--focused]="isFocused()"
  [class.lt-text-input--filled]="hasValue()"
  [class.lt-text-input--error]="hasError() || invalid()"
  [class.lt-text-input--disabled]="disabled()"
  [class.lt-text-input--with-validation-icon]="showValidationIcon()"
  [class.lt-text-input--placeholder-mode]="!hasLabel()"
  [class.lt-text-input--static-label]="staticLabel()"
>
  @if (showValidationIcon()) {
    <lt-icon
      class="lt-text-input__icon"
      [class.lt-text-input__icon--error]="invalid()"
      [class.lt-text-input__icon--success]="!invalid()"
      [class]="invalid() ? 'fasr fa-circle-exclamation' : 'fasr fa-check-circle'"
      [name]="invalid() ? 'fa-sharp-regular-circle-exclamation' : 'fa-sharp-regular-check-circle'"
    ></lt-icon>
  }

  <input
    class="lt-text-input__field"
    [type]="type()"
    [id]="inputId"
    [value]="effectiveValue()"
    [disabled]="disabled()"
    [attr.maxlength]="maxlength()"
    [attr.minLength]="minLength()"
    [attr.autocomplete]="autocomplete()"
    [attr.placeholder]="!hasLabel() ? placeholder() : null"
    [attr.data-testid]="testId()"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
  />
  @if (hasLabel()) {
    <label class="lt-text-input__label" [class.lt-text-input__label--required]="required()" [for]="inputId">
      {{ label() }}
    </label>
  }
</div>

@if (hasError()) {
  <div class="lt-text-input__error">
    {{ error() }}
  </div>
}
